import React from 'react';
import type { NextPage } from 'next';

import WindStationMap from 'containers/WindStationMap';
import { getOrCreateStore, type ReduxInitialProps } from 'stores';

const WindStationMapPageWithLocation: NextPage<
  {},
  ReduxInitialProps & { isMapV2Page: true; mapMode: 'windStation' }
> = () => <WindStationMap />;

WindStationMapPageWithLocation.getInitialProps = async (context) => {
  const isServer = !!context.req;
  const { location } = context.query as { location: string };

  if (isServer) {
    const newrelic = require('newrelic');
    newrelic.addCustomAttributes({
      location,
    });

    const store = getOrCreateStore();
    return {
      enableCssBaseline: true,
      enableTheme: true,
      isAppBannerEnabled: true,
      isFooterVisible: false,
      isMapV2Page: true,
      mapMode: 'windStation',
      ssrReduxState: store.getState(),
    };
  }

  return {
    enableCssBaseline: true,
    enableTheme: true,
    isAppBannerEnabled: true,
    isFooterVisible: false,
    isMapV2Page: true,
    mapMode: 'windStation',
  };
};

export default WindStationMapPageWithLocation;
